import { BadgeCheck, ClipboardCheck, Ruler } from "lucide-react";
import { useMenuAccess } from "@/app/access";
import { SettledRules } from "@/components/ui/SettledRules";

/**
 * Quy tắc của Chất lượng — chốt 20/09/2026 theo chuẩn, khách bác lại được. Trước đây là mười một thẻ vàng rải trên ba màn con
 * (kiểm hàng đầu vào, tiêu chuẩn kiểm, phiếu lỗi), mỗi thẻ kèm một câu hỏi để ngỏ; nay mỗi màn con đọc đúng bộ quy tắc của mình.
 *
 * Phần thật sự phải hỏi khách — kiểm cái gì, ngưỡng đạt/rớt bao nhiêu, lấy mẫu theo phương án nào, công thức chấm điểm nhà cung
 * cấp — nằm ở mục 29 bộ câu hỏi. Đó là DỮ LIỆU và CHÍNH SÁCH của Hisense; hệ chốt cách làm để màn hình dùng được ngay và
 * KHÔNG tự đặt ra một con số nào. Đúng tinh thần IQC-R01: thiếu ngưỡng thì ghi "chưa đánh giá", không bao giờ tự cho Đạt.
 */
export const IQC_RULES_SETTLED = ["criteria", "allocation", "documents", "arrival", "authority"] as const;
export const SPEC_RULES_SETTLED = ["limits", "acceptance", "rework"] as const;
export const NCR_RULES_SETTLED = ["source", "close", "assessment"] as const;

export function IqcRules() {
  return <SettledRules ns="iqc" rules={IQC_RULES_SETTLED} icon={ClipboardCheck} />;
}
export function QualitySpecRules() {
  return <SettledRules ns="qualitySpecs" rules={SPEC_RULES_SETTLED} icon={Ruler} />;
}
export function NcrRules() {
  return <SettledRules ns="ncr" rules={NCR_RULES_SETTLED} icon={BadgeCheck} />;
}

/**
 * Cùng bộ giải quyền với máy chủ (ô tick menu Chất lượng).
 *
 * Trước 20/09/2026 màn này chặn theo vai trò ở năm chỗ trên web (`role==='admin'` hoặc `'manager'`), nên tài khoản phân quyền
 * riêng mở được mục Chất lượng rồi không thấy gì — còn API thì xếp `/iqc` vào menu Kho & LOT nên cũng trả 403.
 */
export function useQualityAccess() {
  return useMenuAccess("quality");
}
